// Vuex Script
// Version		          : 1.0.0.0
// Template Modified Date : 19/09/2020 10:00:00 AM
// File Created Date      : 19/09/2020 10:00:00 AM

export default {
    namespaced: true,
    //#. An object containing the data
    state: {
        card: {
            type: 'Grid'
        },
        parentComponent: true,
        hideButtons: ['Edit'],
        // actions: {
        //     listAction: '/api/AdminDashboard/ListApplication/',
        //     deleteAction: "/api/AdminDashboard/ListApplication/",
        // },
        fields: {
            GrantId: {
                primaryKey: true,
            },
            GrantCode: {
                title: "Grant Code",
                value: "GrantCode",
                type: "TextInput",
            },
            ApplicationId: {
                title: " App No.",
                value: "Code",
                type: "TextInput",
            },
            Title: {
                title: "Title",
                value: "Title",
                type: "TextInput",
                width: 250
            },
            Region: {
                title: "Region",
                value: "Region",
                type: "TextInput",
            },
            Latitude: {
                title: "Lat.",
                value: "Latitude",
                type: "TextInput",
            },
            Longitude: {
                title: "Long.",
                value: "Longitude",
                type: "TextInput",
            },
            TotalProjectBudget: {
                title: "Total Project Budget",
                value: "TotalProjectBudget",
                type: "Number",
            },
            RequestedAmount: {
                title: "Requested Amount",
                value: "RequestedAmount",
                type: "Number",
            },
            Initiative: {
                title: "Initiative",
                value: "Name",
                required: true,
            },
            StepName: {
                title: "Status",
                value: "StepName",
                type: "TextInput",
            },
            Edit: {
                tooltip: "Edit",
                prepend: true,
                type: "button",
                icon: "mdi-pencil",
                size: "20",
                color: "#557fb5",
                event: "edit",
                exportable: false,
            },
        },

        // Default
        authorized: false,
        loggedInUser: '',
        userId: 0,
        avatar: '',
        applicationName: 'IUCN Grants Portal',

        /* --- A --- */
        accessDeny: false,
        ajaxFormSubmit: true,
        ajaxError: false,
        ajaxMessage: null,
        appTitle: null,
        autoOpenItems: [],
        auditReport: false,

        /* --- B --- */
        browserAutocomplete: false,
        buttonDisabled: false,
        buttonGroup: false,

        childComponents: false,
        collapseOnScroll: true,
        columnIndex: null,
        contentHeader: null,
        contextMenu: true,
        contextMenuIndex: null,
        componentId: window.location.hash.substr(1),
        currency: {
            enabled: false,
            decimal: '.',
            thousands: ',',
            precision: 2,
            masked: false
        },
        currentOperation: {
            _create: 'Add',
            _update: 'Edit',
            _delete: 'Delete',
        },

        /* --- D --- */
        defaultDateFormat: 'DD/MM/YYYY',
        defaultDateWithTime: "DD/MM/YYYY h:mm:ss A",
        displayCurrentDate: false,
        downloadAction: process.env.VUE_APP_API_Base_URL + 'api/PanERPActions/GetDownloadFiles',
        downloadFiles: [],
        multiSelectKey: 'DocumentStoreId',

        /* --- E --- */
        emptyRowIndex: -1,
        enabledAdd: false,
        extraParams: null,
        exportOption: {
            enabled: true,
            xls: false,
            csv: false,
            xlsx: true,
            zip: true,
        },
        exportableFields: {},

        /* --- F --- */
        files: {
            userIcon: 'treeview-icon-user',
            panelIcon: 'panel-icon-user',
        },
        fixedHeader: false,
        formData: [],
        formCreate: false,
        formEdit: false,
        formGroups: [],
        formView: true,
        formulaTypes: {
            sum: "sum",
            average: "avg",
            min: "min",
            max: "max",
            count: "count",
            custom: "custom"
        },
        fullScreen: false,

        /* --- G --- */
        getTemplate: '/api/Dashboard/GetTemplate/',
        grandParent: null,
        grouping: {
            enabled: false,
            collapse: false,
            title: '',
            defaultGroupBy: []
        },

        /* --- H --- */
        headers: [],
        headerMaxLength: null,
        headerTooltip: '',
        hotkeys: {
            enabled: true
        },
        hyperLink: true,

        /* --- I --- */
        importOption: {
            enabled: false,
            previewDialog: false,
            processLogDialog: false,
            preview: false
        },
        inlineAddContextItems: {},
        inlineContextItems: {},
        inlineEditor: {
            enabled: false,
            emptyRow: false,
            autoSave: true,
        },
        invertedScroll: true,
        isDirty: false,
        isSidePanel: true,
        items: {},
        showSaveFilter: false,
        saveAndContinue: true,
        showRowNumber: false,

        /* --- M --- */
        messages: {
            accessDenyText: 'You have limited permission to access',
            accessDenied: 'Access Denied',
            add: 'Add',
            edit: 'Edit',
            delete: 'Delete',
            close: 'Close',
            cancel: 'Cancel',
            save: 'Save',
            new: 'New',
            csvExport: 'CSV Export',
            excelExport: 'Excel Export',
            export: 'Export',
            expand: 'Expand',
            collapse: 'Collapse',
            dateSelection: 'Select Date',
            itemsPerPageText: 'Rows per page',
            pageText: '{0}-{1} of {2}',
            search: 'Search',
            saveContinue: 'Save & Continue',
            tooltipEditor: 'Tooltip Editor',
            cardFill: 'Please fill out required fields in the General Info Card and press the Save button.',
            changesConfirm: 'Your changes will be lost. Are you sure?',
            confirm: 'Confirm',
            dashboardClose: 'Are you sure you want to close?',
            deleteConfirm: 'Are you sure you want to delete this record?',
            download: 'Click here to download ',
            invalidDate: 'Invalid date',
            invalidDateMessage: 'Invalid date format. Please enter the date in the format ',
            loading: 'Loading...',
            noFileSelected: 'No file selected.',
            noResults: 'No matching records found',
            noData: 'No data available',
            rowFill: 'Kindly fill the previous row',
            success: 'Success',
            successCreate: 'The record is created successfully.',
            successUpdate: 'The record is updated successfully.',
            successDelete: 'The record is deleted successfully.',
            permissionWarn: 'You don\'t have sufficient permission for do this operation'
        },
        keyTranslator: true,
        moduleName: '',
        multiColumn: 'Auto',

        /* --- N --- */
        notyTypes: { error: 'error', info: 'info', success: 'success' },

        /* --- O --- */
        orginalFields: null,

        /* --- P --- */
        permission: { create: 'A', edit: 'E', delete: 'D' },
        permissions: '',
        placeholder: ' ',
        progress: false,
        progressCircular: false,

        /* --- R --- */
        renderComponent: false,
        renderTitleComponent: true,
        renderTitleSearchComponent: true, // using title search component button enabled or disabled
        required: false,
        rowMenuButtons: { enabled: false },
        activeRow: {},

        /* --- S --- */
        search: '',
        searchComponent: false,
        selecting: false,
        multiselect: false,
        selectedItems: [],
        simpleSearch: true,
        simplefilter: null,
        skipNullField: false,
        showModal: false,
        summaryPanel: {
            enabled: false,
            position: "bottom", // or bottom
            sticky: true
        },

        /* --- T --- */
        theme: {
            dense: false,
            dark: false, // default light color
            font: 'md',  // or sm, md,lg
            icon: 'md'  // or sm, md,lg
        },
        title: '',
        titleSearch: null,
        type: {
            _form: 'Form',
            _formNoLabel: 'FormNoLabel',
            _formLabelLeft: 'FormLabelLeft',
            _formLabelRight: 'FormLabelRight',
            _formLabelTop: 'FormLabelTop',
            _grid: 'Grid',
            _inlineEdit: 'Inline',
            _tree: 'Tree',
            _treeTable: 'TreeTable'
        },
        tooltipsFormData: [],
        tooltipsList: [],
        tooltipsDialog: false,
        treeTable: {
            collapse: false
        },

        /* --- Snackbar --- */
        color: 'success',
        mode: '',
        snackbar: false,
        text: '',
        timeout: 5000,
        y: 'top',
        x: null,

        /* --- Grid --- */
        loading: true,
        isMobile: false,
        selected: [],
        indeterminate: true,
        pagination: {
            enabled: true,
            itemsPerPage: 1,
            rowsPerPageItems: [],
            pageSize: 10,
            page: 1
        },

        /* --- Sidepanel --- */
        sidebar: {
            enabled: true,
            collapse: true,
            position: 'left'
        },
        sorting: {
            descending: true,
            sortBy: ''
        },

        /* --- Tree --- */
        autoOpen: false,
        custom: false,
        caseSensitive: {
            enabled: true,
            sensitive: true,
        },

        workflow: {
            workflowImplemented: false
        },

        /* --- Form --- */
        dialogPosition: 'center',
        dialog: false,
        landscape: false,
        renderDatepicker: true,
        editedIndex: -1,
        editedItem: {},
        mapItem: {},
        showInputs: true,
        disabled: true,
        dialogClass: 'dialog-width-md',

        /* --- Date --- */
        picker: null,
        dateId: null,
        formatted: null,
        dateFormatted: '',
        date: new Date().toISOString().substr(0, 10),
        renderTable: true,
        renderForm: true,
        datepicker: {
            closeOnContentClick: false
        },

        notify: {
            enabled: false,
            timeout: 5000,
            color: 'success',
            text: null,
            mode: '',
            y: 'top',
            x: null,
        },

        url: {
            area: window.location.pathname.split('/')[1],
            controller: window.location.pathname.split('/')[2]
        },

        /* --- X --- */
        xlsxColumns: [],
        zipName: null,
        zipCustomName: null
    },

    //#. Used to access data from the state tree of the store
    getters: {},

    //#. Handler functions that perform modifications of data in the state tree
    mutations: {
        //#. fn_formCreated function
        formCreated(state, payload) { },

        //#. fn_formCancel function
        formCancel(state, payload) { },

        //#. fn_recordCreated function
        recordCreated(state, payload) { },

        //#. fn_recordUpdated function
        recordUpdated(state, payload) { },

        //#. fn_recordDeleted function
        recordDeleted(state, payload) { },

        //#. fn_loadingRecords function
        loadingRecords(state, payload) { },

        //#. fn_recordsLoaded function
        recordsLoaded(state, payload) { },

        //#. fn_selectionChanged function
        selectionChanged(state, context) { },

        editApplication(state, context) { },

        downloadApplication(state, context) { }
    },

    //#. Functions that commit mutations. The main difference to Mutations is that Actions can contain asynchronous operations
    actions: {
        //#. formCreated event will be fired
        formCreated: ({ commit, rootState }, payload) => {
            commit('formCreated', { rootState, payload });
        },

        //#. formCancel event will be fired
        formCancel: ({ commit, rootState }, payload) => {
            commit('formCancel', { rootState, payload });
        },

        //#. recordAdded event will be fired
        recordCreated: ({ commit, rootState }, payload) => {
            commit('recordCreated', { rootState, payload });
        },

        //#. recordUpdated event will be fired
        recordUpdated: ({ commit, rootState }, payload) => {
            commit('recordUpdated', { rootState, payload });
        },

        //#. recordUpdated event will be fired
        recordDeleted: ({ commit, rootState }, payload) => {
            commit('recordDeleted', { rootState, payload });
        },
        //#. loadingRecords event will be fired
        loadingRecords: ({ commit, rootState }, payload) => {
            commit('loadingRecords', { rootState, payload });
        },

        //#. recordsLoaded event will be fired
        recordsLoaded: ({ commit, rootState }, payload) => {
            commit('recordsLoaded', { rootState, payload });
        },
        //#. selectionChanged event will be fired	
        selectionChanged: ({ commit, rootState }, payload) => {
            commit('selectionChanged', { rootState, payload });
        },

        //#. getPasswordReset event will be fired
        editApplication: ({ commit, dispatch, rootState }, payload) => {
            // dispatch('application/getApplication', null, { root: true });
            // dispatch('application/setApplicationId', payload.item.ApplicationId, { root: true });
            // commit('editApplication', { rootState, payload });
        },

        downloadApplication: ({ commit, dispatch, rootState }, payload) => {
            // dispatch('application/getApplication', payload.item.ApplicationId, { root: true });
            // commit('downloadApplication', { rootState, payload });
        }
    }
}
